import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';

import { EMPTY, Observable, Subscription } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';
import { DataService, LoaderHandlerService } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class HttpGuardService implements OnDestroy {

  private _subscription: Subscription;
  private _sessionTimeoutFlag: boolean = false;

  constructor(private http: HttpClient, private loaderHandler: LoaderHandlerService, private _dataService: DataService) {
    this._subscription = this._dataService.events.subscribe((res: any) => {
      if (res.name === 'sessionTimeout' || res.name === 'tenantExpired') {
        this._sessionTimeoutFlag = true;
      }
    });
  }

  ngOnDestroy() : any {
    this._subscription?.unsubscribe();
  }

  httpReq(reqType: string, baseURL: string, endURL: string, data?: any, loaderNeeded = true, observe: 'events' | 'response' = 'events', pageType?: string ): Observable<any> {
    if (!this._sessionTimeoutFlag) {
      let fullURL = baseURL ? ApiConstants[baseURL] + endURL : endURL;
      let headers = new HttpHeaders();
      if (loaderNeeded) {
        this.loaderHandler.toggleLoader(1);
      }
      if (pageType) {
        headers = headers.set('page-type', pageType);
      }
      if (baseURL === 'azureBlobBaseUrl') { fullURL = endURL; }
      switch (reqType) {
        case 'get':
          const getURL = data ? fullURL + data : fullURL;
          return this.http.get(getURL, { headers });
        // for future exception handle
        // const encodedURL = this.encodeURL(fullURL, data);
        // .pipe(
        //   tap(res => this.handleHTTPSuccess(res)),
        //   catchError(this.handleError('error', []))
        // );
        case 'post':
          return this.http.post(fullURL, data, { headers });
        case 'post-csv-json':
          return this.http.post(fullURL, data, { responseType: 'text', observe: "response", headers, });
        case 'post-csv-json-blob':
          return this.http.post(fullURL, data, { responseType: 'blob', observe: "response", headers, });
        case 'put':
          if (observe === 'events') {
            return this.http.put(fullURL, data, { observe: 'events', reportProgress: true, headers });
          } else {
            return this.http.put(fullURL, data, { headers });
          }
        case 'delete':
          return this.http.delete(fullURL, { observe: 'response', headers });
        case 'delete-post':
          return this.http.delete(fullURL, { body: data, headers });
        case 'patch':
          return this.http.patch(fullURL, data, { headers });
        case 'get-blob':
          const getBlobURL = data ? fullURL + data : fullURL;
          return this.http.get(getBlobURL, { responseType: 'blob', headers });
        case 'post-blob':
          return this.http.post(fullURL, data, { responseType: 'blob', headers });
        // check default
        default: return null;
      }
    } else {
      return EMPTY;
    }
  }
}